<template>
  <v-dialog v-model="tAndCModal" width="1000">
    <v-card>
      <v-card-title>
        <h3 class="pb-1 mb-0">
          Terms and Conditions
        </h3></v-card-title
      >

      <v-row class="w-100 bespoke-margin">
        <div class="w-100 text-center mt-3">
          <!-- Terms And Conditions -->
          <div class="mb-3">
            <p v-html="termsCopy" class="text-center" />
          </div>
        </div>
      </v-row>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="$emit('hideDialog')">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TermsAndConditions",
  props: {
    termsCopy: {
      type: String,
      required: true
    },
    tAndCModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    async showModal() {
      this.$refs["terms-conditions-ref"].show();
    },
    hideModal() {
      this.$refs["terms-conditions-ref"].hide();
    }
  }
};
</script>
